import { CountdownDetails } from './types';

export function calculateIsTimeLeft(countdownDetails: CountdownDetails) {
  return countdownDetails.timeDifference > 0;
}
